import { usePosModeActions } from '@/features/pos/contexts/PosMode'
import { useAppDispatch } from '@/hooks/redux'
import { clearSelectedOrderUuid } from '@/redux/reducers/orders'
import { Stack, useFocusEffect } from 'expo-router'
import { FC, useCallback } from 'react'

const Layout: FC = () => {
    const dispatch = useAppDispatch()
    const { setPhone } = usePosModeActions()

    useFocusEffect(
        useCallback(() => {
            setPhone()

            return () => {
                dispatch(clearSelectedOrderUuid())
            }
        }, [setPhone, dispatch])
    )

    return <Stack screenOptions={{ headerShown: false }} />
}

export default Layout
